<template>
  <div class="title-desc-tutorial" :class="theme">
    <h2 class="title">{{ title }}</h2>
    <ul class="desc">
      <li v-for="(item, index) in descList" :key="index">{{ item }}</li>
    </ul>
    <div class="tutorial">
      <h3>{{subType ? $t('overview.manageAssets.subTitle') : $t('overview.privateWallet.subTitle')}}</h3>
      <ul class="tutorial-list">
        <li v-for="(item, index) in videoList" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subType: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    descList: {
      type: Array,
      default: () => {
        return []
      }
    },
    videoList: {
      type: Array,
      default: () => {
        return []
      }
    },
    theme: {
      type: String,
      default: ''
    }
  },
  mounted () {
    console.log(this.title)
  }
}
</script>

<style lang="css">
.title-desc-tutorial {
  width: 100%;
  position: relative;
  z-index: 5;
}


.title-desc-tutorial .title {
  font-size: 40px;
  color: #111111;
}

.title-desc-tutorial .desc {
  font-size: 16px;
  line-height: 32px;
  color: #333;
  margin-top: 20px;
  padding-left: 20px;
}

.title-desc-tutorial .desc li {
  position: relative;
  display: list-item;
  list-style-type: disc;
}


.title-desc-tutorial .tutorial {
  background-color: #F5C507;
  border-radius: 12px;
  padding: 24px 0;
  margin-top: 24px;
  padding: 24px 0;
}

.title-desc-tutorial .tutorial h3 {
  font-size: 24px;
  line-height: 29px;
  margin-left: 24px;
}

.title-desc-tutorial .tutorial ul {
  margin-top: 12px;
}

.title-desc-tutorial .tutorial ul li {
  line-height: 1.5em;
  background: url('../../assets/img/ic_video_black_nor.svg') no-repeat 24px 13px;
  background-size: 20px;
  padding: 12px 24px 12px 56px;
}

.title-desc-tutorial .tutorial ul li:hover {
  background-image: url('../../assets/img/ic_video_black_hover.svg');
  background-color: #EDB707;
}

.title-desc-tutorial .tutorial a:link,
.title-desc-tutorial .tutorial a:visited {
  color: #333;
  text-decoration: underline;
}

.theme_chat,
.theme_chat .title,
.theme_chat ul li,
.theme_chat .tutorial a:link,
.theme_chat .tutorial ul a:visited {
  color: #fff;
}
.theme_chat .tutorial {
  background-color: rgba(255,255,255,0.05);
}
.theme_chat .tutorial ul li:hover {
  background-color: rgba(255,255,255,0.1);
  background-image: url('../../assets/img/ic_video_white_hover.svg');
}

.theme_chat .tutorial ul li {
  background-image: url('../../assets/img/ic_video_white_nor.svg');
  background-color: none;
}

.theme_assets .tutorial {
  background-color: #F7F9FC;
} 
.theme_assets .tutorial ul li {
  color: #333;
  background-image: url('../../assets/img/ic_video_black_nor.svg');
}
.theme_assets .tutorial ul li:hover {
  background-color: #FFDD19;
  background-image: url('../../assets/img/ic_video_black_hover.svg');
}

@media screen and (max-width: 768px) {
  .title-desc-tutorial .desc {
    margin-top: 15px;
  }
}

</style>